import io from 'socket.io-client'
import { IActivity } from '@zunta/configurations'
import { SOCKET_PATH } from '@/constants'
import Api from '@/api'
import { bus } from '@/plugins/eventBus'

class SocketManager {
  socket: any

  public install (Vue: any) {
    Vue.prototype.$socketManager = this
    const token = Api.getToken()
    if (token) {
      this.init(token)
    }
    bus.$on('initToken', (token: string) => this.init(token))
  }

  send (eventName: string, data?: any) {
    this.socket.emit(eventName, data)
  }

  init (token: string) {
    if (this.socket) {
      this.socket.query.authorization = `Bearer ${token}`
      return
    }

    this.socket = io(SOCKET_PATH, {
      transports: ['websocket'],
      reconnection: true,
      secure: true,
      query: {
        authorization: `Bearer ${token}`
      }
    })

    this.socket.on('connect', () => {
      this.socket.emit('subscriptToActivities')
    })

    this.socket.on('reconnect', () => {
      if (document.URL.includes('app/admin')) {
        this.subscribeToPccRequestUpdates()
        this.subscribeToPccDepositUpdates()
        // this.subscribeToEligibilityTaskUpdates()
      }
    })

    this.socket.on('activity', (activity: IActivity) => bus.$emit('activity', activity))
    this.socket.on('activities', (activities: IActivity[]) => bus.$emit('activities', activities))
    this.socket.on('notifyPccRequestUpdate', (update: boolean) => bus.$emit('notifyPccRequestUpdate', update))
    this.socket.on('notifyPccDepositUpdate', (update: boolean) => bus.$emit('notifyPccDepositUpdate', update))
    this.socket.on('notifyEligibilityTaskUpdate', (data: {userId?: number, taskId?: number, tasksCount?: number}) => bus.$emit('notifyEligibilityTaskUpdate', data))
    this.socket.on('updateAppVersion', (version: any) => bus.$emit('updateAppVersion', version))
  }

  public subscribeToPccRequestUpdates () {
    this.send('subscribeToPccRequestUpdates')
  }

  public subscribeToPccDepositUpdates () {
    this.send('subscribeToPccRequestUpdates')
  }

  public subscribeToEligibilityTaskUpdates () {
    this.send('subscribeToPccRequestUpdates')
  }
}

const socketManager = new SocketManager()

export default socketManager
